require("!!/home/a_korolev/projects/wg-riddler/node_modules/script-loader/addScript.js")(require("!!/home/a_korolev/projects/wg-riddler/node_modules/script-loader/node_modules/raw-loader/index.js!/home/a_korolev/projects/wg-riddler/node_modules/localforage/dist/localforage.min.js"))


/*****************
 ** WEBPACK FOOTER
 ** ./~/script-loader!./~/localforage/dist/localforage.min.js
 ** module id = 1
 ** module chunks = 0
 **/